import { render, staticRenderFns } from "./ClientsExternal.vue?vue&type=template&id=9abe2b18&scoped=true&"
import script from "./ClientsExternal.vue?vue&type=script&lang=js&"
export * from "./ClientsExternal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9abe2b18",
  null
  
)

export default component.exports